import React, { useState, useEffect } from 'react';
import { useLoading } from '../../context_providers/loading_context/LoadingContext';

const TransitionWrapper = ({ children }) => {
  const [isFadingIn, setIsFadingIn] = useState(false);
  const { isLoading, transitionComplete } = useLoading();

  useEffect(() => {
    if (!isLoading && transitionComplete && !isFadingIn) setIsFadingIn(true);
  }, [isLoading, transitionComplete]);

  return (
    <div className={`fade-transition ${isFadingIn ? 'fade-in' : ''}`}>
      {children}
    </div>
  );
};

export default TransitionWrapper;
